import axios from 'axios'
import {errorHelper, messageHelper} from '../helper.js'
import {
    REQUEST_URL, 
    PROPOSAL_DETAIL_URL, 
    MY_PROPOSALS_URL, 
    PROFILE_LIST_URL, 
    PROFILE_ADMIN_DETAIL_URL, 
    ALL_ORGANIZATIONS_URL,
} from '../../../vars'

/**
 * @namespace User
 * @description Список всех заявок (Page: /user)
 */
export default {
    state: {
        currentProfileId: null,
        showUserCard: false,
        UserCallId: null,
        needReloadCloseUser: false,
        userAll: [],
        all_organizations: [],
    },

    mutations: {
        UPDATE_USER_ALL(state, data) {
            state.userAll = data;
        },

        SHOW_USER_CARD(state, data){
            state.currentProfileId = data['profile_id'];
            state.UserCallId = data['call_id'];
            state.showUserCard = true;
            state.needReloadCloseUser = false;
        },

        CLOSE_USER_CARD_MUTATION(state, data){
            state.showUserCard = false;
            if(data['need_reload_parent'])
                state.needReloadCloseUser = state.UserCallId;
        },

        UPDATE_ALL_ORGANIZATIONS(state, data) {
            state.all_organizations = data;
        },
    },

    getters: {
        GETTERS_NEED_RELOAD_CLOSE_USER(state){
            return state.needReloadCloseUser;
        },

        GETTERS_CURRENT_PROFILE_ID(state){
            return state.currentProfileId;
        },
        GETTERS_SHOW_USER_CARD(state){
            return state.showUserCard;
        },
        GETTERS_USER_ALL(state) {
            return state.userAll;
        },

        GETTERS_ALL_ORGANIZATIONS(state){
            return state.all_organizations
        },

    },
    actions: {
        async LOAD_ALL_ORGANIZATIONS(ctx, lang){
            try {
                await axios.get(`${ALL_ORGANIZATIONS_URL}?lang=${lang}`)
                .then((res) => ctx.commit('UPDATE_ALL_ORGANIZATIONS', res.data))
                .catch((e) => {
                    errorHelper(e);
                    messageHelper('', 'error', 6000, e);
                });

            } catch (ex) {
                console.log('ex store---> ', ex);
                messageHelper('', 'error', 6000, ex);
            }    
        },
        
        async GET_USER_ALL(ctx, id) {
            try {
                const res = await axios.get(`${PROFILE_ADMIN_DETAIL_URL}?id=${id}`, {
                headers: {
                    Authorization: `Token ${localStorage.token}`,
                },
                });

                await ctx.commit('UPDATE_USER_ALL', res.data);

                return res.data;
            } catch (e) {
                errorHelper(e);
                messageHelper('', 'error', 6000, e);
                console.log(e, ' GET_INPUT_ALL');
                throw e;
            }
        },

        async UPDATE_PROFILE_DETAIL(ctx, data) {
            try {
                const res = await axios.patch(`${PROFILE_ADMIN_DETAIL_URL}`, data, {
                headers: {
                    Authorization: `Token ${localStorage.token}`
                }
                })
                console.log(res)
                return res
            } catch (e) {
                errorHelper(e)
                messageHelper('', 'error', 6000, e)
                throw e
            }
        },
        
        CLOSE_USER_CARD(ctx, data){
            ctx.commit('CLOSE_USER_CARD_MUTATION', data);
        },
        /**
         * Получает список BS и записывает
         * @param {Object} ctx
         * @throws {Object} Ошибка запроса данных
         *
         * @memberof Main
         */
        async LOAD_PROFILE_LIST(ctx, data) {
            try {
                const res = await axios.get(`${PROFILE_LIST_URL}?type=${data.type}`, {
                    headers: {
                        Authorization: `Token ${localStorage.token}`,
                    },
                });
                return res.data

            } catch (ex) {
                console.log('ex store---> ', ex);
                messageHelper('', 'error', 6000, ex);
            }    
        },

        /**
         * Получает данные
         * @param {Object} ctx 
         * @param {Object} data Данные для запроса списка proposal
         * @throws {Object} Ошибка запроса данных
         * 
         * @memberof User
         */
        async LOAD_LIST_MY_PROPOSALS(ctx, data) {
            try {
                var view_type = data.view_type
                const res = await axios.get(`${MY_PROPOSALS_URL}?view_type=${view_type}`, {
                    headers: {
                        Authorization: `Token ${localStorage.token}`,
                    }
                });
                return res.data;
                
            } catch(e) {
                errorHelper(e)
                messageHelper('', 'error', 6000, e)
                console.log('LOAD_LIST_PROPOSALS', e)
                throw e
            }
        },

        /**
         * Создает proposal и перенаправляет на созданный proposal
         * @param {Object} ctx 
         * @param {Object} data Данные для создания proposal 
         * @throws {Object} Ошибка запроса данных
         * 
         * @memberof User
         */
        async CREATE_PROPOSAL(ctx, data) {

            try {
                const res = await axios.post(`${PROPOSAL_DETAIL_URL}`, {
                    applicant_id: data.id,
                }, {headers: {
                    Authorization: `Token ${localStorage.token}`,
                }});

                window.location.href = `/new-proposal/${res.data.id}`
            } catch(e) {
                errorHelper(e)
                messageHelper('', 'error', 6000, e)
                console.log('CREATE_PROPOSAL', e)
                throw e
            }
        },
        
        /**
         * Удаляет proposal
         * @param {Object} ctx 
         * @param {Object} data Данные для удаления proposal
         * @throws {Object} Ошибка запроса данных
         * 
         * @memberof User
         */
        async DELETE_REQUEST(ctx, data) {
            try {
                await axios.post(`${REQUEST_URL}`, {
                    proposal_id: data.deleteId,
                    status_slug: 'deleted',
                    init_by: data.id,
                }, {headers: {
                    Authorization: `Token ${localStorage.token}`,
                }})
            } catch(e) {
                errorHelper(e)
                messageHelper('', 'error', 6000, e)
                console.log('DELETE_REQUEST', e)
                throw e
            }
        }
    }
}